<div class="white-bg">
  <breadcrumbs>
    <breadcrumb route="/" [label]="'Dashboard' | translate | async"></breadcrumb>
    <breadcrumb route="/inspection" [label]="'Find Inspection' | translate | async"></breadcrumb>
    <breadcrumb [currentRoute]="true" [label]="'Interpretation' | translate | async"></breadcrumb>
    <div style="display: flex; margin-left: 200px;">
          <span style="font-size: 14px; font-weight: 600; color: #222;">
            {{'Equipment Summary Notes' | translate | async}}
          </span>
          <button 
            mat-icon-button
            [matTooltip]="'Equipment Summary Notes' | translate | async"
            (click)="openSummaryNotes()"
            style="width: 28px; height: 28px;">
            <span *ngIf="overviewModel.Equipment.SummaryNotesExists" style="cursor: pointer;">
            <i class="material-icons upload-container__icon" style="color: #ed5565;">
              message
            </i>
          </span>
          <span *ngIf="!overviewModel.Equipment.SummaryNotesExists" style="cursor: pointer;">
            <i class="material-icons observation-image__icon" >
              message
            </i>
          </span>
          </button>
    </div>
  </breadcrumbs>
  <div class="content" *ngIf="hasPermission">
    <div class="overview">
      <overview-image [src]="getImage(overviewModel.Equipment.EquipmentPhoto)"
        [equipmentId]="overviewModel.Equipment.EquipmentId" [image]="overviewModel.Equipment.EquipmentPhoto"
        [InspectionId]="_inspectionId" (eventClick)="changeEvalInChildClicked($event)" [eval]="overallEval"
        (loadImage)="updateImage($event)" evalBackground="{{overallEval | lowercase}}"
        [loading]="overviewIsLoading" [IsInterp]="true" [WorstWornL]="worstWornLeft" [WorstWornR]="worstWornRight"
        [WorstEvalL]="worstEvalLeft" [WorstEvalR]="worstEvalRight"></overview-image>

      <div class="overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="translate('Serial Number')" [primary]="true" [loading]="overviewIsLoading">
              <a routerLink="/equipment/{{overviewModel.Equipment.EquipmentId}}"
                [matTooltip]="translate('Manage Equipment')">{{overviewModel.Equipment.SerialNumber}}</a>
            </item>
            <item [label]="translate('Unit Number')" [primary]="true" [loading]="overviewIsLoading">
              <a routerLink="/equipment/{{overviewModel.Equipment.EquipmentId}}"
                [matTooltip]="translate('Manage Equipment')">{{overviewModel.Equipment.UnitNumber}}</a>
            </item>



            <item *ngIf="overviewModel.Equipment.AdditionalUnitNo!=null" [primary]="true"
              [label]="translate('Additional Unit Number')" [loading]="overviewIsLoading">
              {{overviewModel.Equipment.AdditionalUnitNo}}</item>
            <item [label]="translate('Make')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Make}}</item>
            <item [label]="translate('Model')" [loading]="overviewIsLoading">{{overviewModel.Equipment.Model}}</item>
            <item [label]="translate('Inspection Id')" [loading]="overviewIsLoading">{{overviewModel.InspectionId}}
            </item>
            <item *ngIf="showWorkOrder" [label]="translate('Work Order')" [loading]="overviewIsLoading">

              <div *ngIf="!isEditingWorkOrder" class="workorder-view">
                <span>{{ overviewModel.WorkOrder }}</span>

                <mat-icon class="edit-icon" (click)="enableWorkOrderEdit()">
                  edit
                </mat-icon>
              </div>

              <!-- Edit mode -->
              <div *ngIf="isEditingWorkOrder" class="workorder-edit">
                <input type="text" class="workorder-input" [(ngModel)]="overviewModel.WorkOrder"
                  (blur)="disableWorkOrderEdit()" (keyup.enter)="disableWorkOrderEdit()" />

                <mat-icon class="done-icon" (click)="disableWorkOrderEdit()">
                  check
                </mat-icon>
              </div>

            </item>
          </item-group>
          <div class="content__primary-buttons" *ngIf="!overviewIsLoading" [@fadeInList]>
            <!-- <button mat-raised-button (click)="downloadTelerikPdf()" style="margin-right: 8px;">
            <i class="material-icons button__icon">save_alt</i>
            {{translate('PDF')}}
          </button> -->
            <a class="button waves-effect" target="_blank"
              href="/api/interpretation/getQuotePDF?inspectionId={{_inspectionId}}&quoteId={{selectedQuoteId}}">
              <i class="material-icons button__icon">save_alt</i>
              <span class="button__text">{{translate('Quote')}}</span>
            </a>
            <!-- <button mat-raised-button (click)="downloadPdf()">
            <i class="material-icons button__icon">save_alt</i>
            {{translate('PDF')}}
          </button> -->
            <button mat-raised-button (click)="downloadTelerikPdf()" [disabled]="savingForm"  [class.loading]="savingForm" [title]="savingForm ? 'Generating PDF, please wait...' : 'Download PDF'">
              <i class="material-icons button__icon">save_alt</i>
              {{translate('PDF')}}
            </button>
            <button mat-raised-button color="warn"
              *ngIf="overviewModel.ReleasedQuoteId !== selectedQuoteId && isInterpreter"
              [matTooltip]="translate('Release Report to Customer')" (click)="releaseReport()"
              [class.loading]="releasing">
              {{translate('Release')}}
            </button>
            <button mat-raised-button color="warn"
              *ngIf="overviewModel.ReleasedQuoteId === selectedQuoteId  && isInterpreter" (click)="openSendReport()">
              {{translate('Send Report')}}
            </button>
          </div>
        </div>
        <div class="content__secondary">
          <div class="special">
            <item-group>
              <div>
                <item [label]="translate('Customer')" [loading]="overviewIsLoading">
                  {{overviewModel.Equipment.CustomerName}}
                </item>
                <item [label]="translate('Job Site')" [loading]="overviewIsLoading">
                  {{overviewModel.Equipment.JobsiteName}}
                </item>
              </div>
              <div>
                <item [label]="translate('Meter Reading (SMU/Hourmeter)')" [loading]="overviewIsLoading">
                  <span style="margin-right: 44%">{{overviewModel.Equipment.SMU}} hrs</span>
                  <span>
                    <span>
                      <condition-photo [inspectionId]="_inspectionId" [isEquipmentSmuHrs]="true"
                        [photo]="overviewModel.Equipment.SMUImagePath" [condition]="Condition.SMUImageHour"
                        (photoChange)="loadOverview()"></condition-photo>
                    </span>

                  </span>
                  <div>
                  </div>
                </item>
                <item [label]="translate('Life to Date (LTD)')" [loading]="overviewIsLoading">
                  {{overviewModel.Equipment.LTD}}
                  hrs
                </item>
              </div>
              <div>
                <item [label]="translate('Forward Travel')" [loading]="overviewIsLoading">
                  <div>
                    <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                      [data]="overviewModel.Equipment.ForwardTravelKM"
                      (dataChanged)="updateForwardReverseReadings($event, ForwardAndReverseOptions.ForwardTravelKm)"
                      [alignRight]="true"></click-to-edit> {{measurementDistance}}
                  </div>
                </item>
                <item [label]="translate('Forward')" [loading]="overviewIsLoading">
                  <div>
                    <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                      [data]="overviewModel.Equipment.ForwardTravelHrs"
                      (dataChanged)="updateForwardReverseReadings($event, ForwardAndReverseOptions.ForwardTravelHrs)"
                      [alignRight]="true"></click-to-edit> Hrs
                  </div>
                </item>
              </div>
              <div>
                <item [label]="translate('Reverse Travel')" [loading]="overviewIsLoading">
                  <div>
                    <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                      [data]="overviewModel.Equipment.ReverseTravelKM"
                      (dataChanged)="updateForwardReverseReadings($event, ForwardAndReverseOptions.ReverseTravelKm)"
                      [alignRight]="true"></click-to-edit> {{measurementDistance}}
                  </div>
                </item>
                <item [label]="translate('Reverse')" [loading]="overviewIsLoading">
                  <div>
                    <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                      [data]="overviewModel.Equipment.ReverseTravelHrs"
                      (dataChanged)="updateForwardReverseReadings($event, ForwardAndReverseOptions.ReverseTravelHrs)"
                      [alignRight]="true"></click-to-edit> Hrs
                  </div>
                </item>
              </div>
              <div>
                <div class="no-margin-right">
                  <item [label]="translate('Total Dist.')" [loading]="overviewIsLoading">
                    {{TotalDistance}}
                    {{measurementDistance}}
                  </item>
                </div>
                <div class="no-margin-right" *ngIf="overviewModel.Equipment.ShowPropelHrsPerc">
                  <item [label]="translate('Propel Hrs')" [loading]="overviewIsLoading">
                    {{overviewModel.Equipment.PropelHrs}}
                  </item>
                </div>
              </div>
              <div>
                <div class="no-margin-right">
                  <item [label]="translate('Reverse Dist. %')" [loading]="overviewIsLoading">
                    {{calculateReversePer(TotalDistance, overviewModel.Equipment.ReverseTravelKM)}} %
                  </item>
                </div>
                <div class="no-margin-right" *ngIf="overviewModel.Equipment.ShowPropelHrsPerc">
                  <item [label]="translate('Propel %')" [loading]="overviewIsLoading">
                    {{overviewModel.Equipment.PropelPerc.toFixed(1)}} %
                  </item>
                </div>
              </div>
              <div>
                <item [label]="translate('Inspection Comment')" [loading]="overviewIsLoading">
                  <div
                    *ngIf="(overviewModel.Equipment.InspectionComment == null || overviewModel.Equipment.InspectionComment.length == 0) && isInspector"
                    class="upload-container"
                    (click)="openInspectionCommentDialog(overviewModel.Equipment.InspectionComment)"
                    title="{{'Add Comment' | translate | async}}">
                    <i class="material-icons upload-container__icon">
                      message
                    </i>
                  </div>
                  <span class="comment" title="{{comment}}"
                    *ngIf="overviewModel.Equipment.InspectionComment != null && overviewModel.Equipment.InspectionComment.length > 0"
                    (click)="openInspectionCommentDialog(overviewModel.Equipment.InspectionComment)">
                    {{
                    overviewModel.Equipment.InspectionComment
                    | slice:0:20
                    }}{{overviewModel.Equipment.InspectionComment.length > 20 ? '...' : ''}}
                  </span>

                </item>
                <item [label]="translate('JobSite Comment')" [loading]="overviewIsLoading">
                  <div
                    *ngIf="(overviewModel.Equipment.JobSiteComment == null || overviewModel.Equipment.JobSiteComment.length == 0) && isInspector"
                    class="upload-container" (click)="openJobsiteCommentDialog(overviewModel.Equipment.JobSiteComment)"
                    title="{{'Add Comment' | translate | async}}">
                    <i class="material-icons upload-container__icon">
                      message
                    </i>
                  </div>
                  <span class="comment" title="{{comment}}"
                    *ngIf="overviewModel.Equipment.JobSiteComment != null && overviewModel.Equipment.JobSiteComment.length > 0"
                    (click)="openJobsiteCommentDialog(overviewModel.Equipment.JobSiteComment)">
                    {{
                    overviewModel.Equipment.JobSiteComment
                    | slice:0:20
                    }}{{overviewModel.Equipment.JobSiteComment.length > 20 ? '...' : ''}}
                  </span>

                </item>
              </div>


            </item-group>
          </div>
          <item-group>
            <item [label]="translate('Inspector')" [loading]="overviewIsLoading">
              <div class="component-container">
                <div matToolip="Change Inspector" disabled="!isInterpreter" [matMenuTriggerFor]="changeInspector"
                  class="text-container" title="Click to edit">
                  <span class="text-container__text"> {{overviewModel.InspectorName}} </span>
                  <i class="material-icons text-container__edit">edit</i>
                </div>

                <mat-menu #changeInspector="matMenu">
                  <button mat-menu-item *ngFor="let inspector of availableInspectors"
                    (click)="changedInspector(inspector)">
                    {{inspector.UserName}}
                  </button>
                </mat-menu>
              </div>
            </item>

            <item [label]="translate('Additional Inspector(s)')" [loading]="overviewIsLoading" disabled="!isInterpreter"  *ngIf="overviewModel.Equipment.ShowAdditionalInspectors">
              <div class="location-inline">
                <div class="location-input-row">
                  <input type="text" title="Press enter to add inspector" [(ngModel)]="overviewModel.newAddiInspector"
                    placeholder="Name"
                    (keydown.enter)="addUpdateAddiInspector(0, overviewModel.newAddiInspector, overviewModel)" />

                  <mat-icon class="icon-btn"
                    (click)="addUpdateAddiInspector(0, overviewModel.newAddiInspector, overviewModel)"
                    title="Add Inspector">add</mat-icon>
                </div>

                <div class="location-list">
                  <div class="location-row" *ngFor="let ins of overviewModel.AdditionalInspectors; let j = index">

                    <!-- Display mode -->
                    <div *ngIf="!ins.editing" class="inspector-label">
                      <span>{{ ins.InspectorName }}</span>
                      <i class="material-icons icon-btn" style="color: black; font-size: 16px; cursor: pointer;"
                        (click)="startEditing(ins)" title="Edit Inspector">edit</i>
                    </div>

                    <!-- Edit mode -->
                    <div *ngIf="ins.editing" class="inspector-edit">
                      <input type="text" [(ngModel)]="ins.InspectorName"
                        (focusout)="finishEditing(ins, overviewModel)" />
                    </div>

                    <mat-icon style="margin-left: 14px; cursor: pointer;" class="icon-btn"
                      (click)="removeAddiInspector(ins.Id, overviewModel)" title="Delete Inspector">
                      delete
                    </mat-icon>
                  </div>
                </div>
              </div>
            </item>


            <div class="no-margin-right">
              <item [label]="translate('Inspection Date')" [loading]="overviewIsLoading">
                {{ overviewModel.InspectionDate |date:'dd/MMM/yyyy'}}
              </item>
            </div>
          </item-group>
          <div *ngIf="DuplicateInspectionIsActive=='0'">
            <item-group *ngIf="IsChild && ParentInspection!=null && isAdministrator">
              <item [label]="'Linked Equipment'" [primary]="true" [loading]="overviewIsLoading">
                <a routerLink="/equipment/{{ParentInspection.EquipmentId}}"
                  target="_blank">{{ParentInspection.SerialNo}}</a>
              </item>
            </item-group>
            <item-group *ngIf="IsParent && ChildInspection!=null && isAdministrator">
              <item [label]="'Parent Equipment'" [primary]="true" [loading]="overviewIsLoading">
                <a routerLink="/equipment/{{ChildInspection.EquipmentId}}"
                  target="_blank">{{ChildInspection.SerialNo}}</a>
              </item>
            </item-group>
            <div class="form-item" *ngIf="!HasLinkedInspection && !IsParent && isAdministrator">
              <button mat-raised-button color="warn" style="margin-left: 20px;margin-right: 20px;"
                      (click)="OpenPopup()">
                {{'Duplicate Inspection' | translate | async}}
              </button>

              <button mat-raised-button color="warn" style="margin-left: 20px;margin-right: 20px;"
                      (click)="UpdateLink()">
                {{'Refresh linked Inspection' | translate | async}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <item-group>
        <item [label]="translate('Underfoot Conditions')" [loading]="overviewIsLoading" *ngIf="showUnderFootConditions">

          <div class="conditions-row">
            <span>
              <div class="conditions-label">
                {{ "Impact *" | translate | async }}
              </div>
            </span>
            <mat-radio-group [(ngModel)]="impactvalue"
              (change)="updateUnderFootConditions(UnderFootConditions.Impacts)">
              <mat-radio-button class="conditons-radio-buttons" [value]="0"> {{ "Low" | translate | async
                }}</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="1">{{ "Medium" | translate | async }}
              </mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="2">{{ "High" | translate | async
                }}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="conditions-row">
            <span>
              <div class="conditions-label">
                {{ "Abrasive *" | translate | async }}
              </div>
            </span>
            <mat-radio-group [(ngModel)]="abrasivevalue"
              (change)="updateUnderFootConditions(UnderFootConditions.Abrasive)">
              <mat-radio-button class="conditons-radio-buttons" [value]="0"> {{ "Low" | translate | async
                }}</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="1">{{ "Medium" | translate | async }}
              </mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="2">{{ "High" | translate | async
                }}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="conditions-row">
            <span>
              <div class="conditions-label">
                {{ "Moisture *" | translate | async }}
              </div>
            </span>
            <mat-radio-group [(ngModel)]="moisturevalue"
              (change)="updateUnderFootConditions(UnderFootConditions.Moisture)">
              <mat-radio-button class="conditons-radio-buttons" [value]="0"> {{ "Low" | translate | async
                }}</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="1">{{ "Medium" | translate | async }}
              </mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="2">{{ "High" | translate | async
                }}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="conditions-row">
            <span>
              <div class="conditions-label">
                {{ "Packing *" | translate | async }}
              </div>
            </span>
            <mat-radio-group [(ngModel)]="packingvalue"
              (change)="updateUnderFootConditions(UnderFootConditions.Packing)">
              <mat-radio-button class="conditons-radio-buttons" [value]="0"> {{ "Low" | translate | async
                }}</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="1">{{ "Medium" | translate | async }}
              </mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="2">{{ "High" | translate | async
                }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </item>
        <!-- might be able to do this in a ngfor -->
        <item *ngIf="visibility('TS') &&showUCCondition && showTrackSag" [label]="translate('Track Sag')"
          [loading]="overviewIsLoading">

          <div class="condition">
            <span class="condition__side">L</span>
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassTSL"
                  [data]="this.overviewModel.Equipment.TrackSagL"
                  (dataChanged)="updateReadings($event, Condition.TrackSagL,'TS_L')"
                  [alignRight]="true"></click-to-edit>{{measurementUnit}}
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.TrackSagCommentL != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.TrackSagCommentL == '' ? ('Add Comment' | translate | async) : overviewModel.Equipment.TrackSagCommentL"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.TrackSagCommentL.length > 0"
              (click)="openConditionComment(Condition.TrackSagL, overviewModel.Equipment.TrackSagCommentL)">
              chat_bubble{{overviewModel.Equipment.TrackSagCommentL.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.TrackSagPhotoL"
              [condition]="Condition.TrackSagL" (photoChange)="loadOverview()"></condition-photo>

          </div>
          <div class="condition">
            <span class="condition__side">R</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.TrackSagR}} mm</span> -->
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassTSR"
                  [data]="overviewModel.Equipment.TrackSagR"
                  (dataChanged)="updateReadings($event,Condition.TrackSagR,'TS_R' )"
                  [alignRight]="true"></click-to-edit>{{measurementUnit}}
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.TrackSagCommentR != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.TrackSagCommentR == '' ? ('Add Comment' | translate | async) : overviewModel.Equipment.TrackSagCommentR"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.TrackSagCommentR.length > 0"
              (click)="openConditionComment(Condition.TrackSagR, overviewModel.Equipment.TrackSagCommentR)">
              chat_bubble{{overviewModel.Equipment.TrackSagCommentR.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.TrackSagPhotoR"
              [condition]="Condition.TrackSagR" (photoChange)="loadOverview()"></condition-photo>
          </div>
          <!--code for bar type-->
          <div class="condition" *ngIf="overviewModel.Equipment.EnableEqualiserBar">
            <span class="condition__reading">{{'Equaliser Bar Type' | translate | async }}</span>
            <i *ngIf="overviewModel.Equipment.EqualiserBarTypeComment != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.EqualiserBarTypeComment == '' ? ('Add Comment' | translate | async) : overviewModel.Equipment.EqualiserBarTypeComment"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.EqualiserBarTypeComment.length > 0"
              (click)="openConditionComment(Condition.EqualiserBarTypeComment, overviewModel.Equipment.EqualiserBarTypeComment)">
              chat_bubble{{overviewModel.Equipment.EqualiserBarTypeComment.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.EqualiserBarTypeImage"
              [condition]="Condition.EqualiserBarTypeImage" (photoChange)="loadOverview()"></condition-photo>
          </div>
          <!--code for bar type-->
        </item>
        <item *ngIf="showUCCondition && visibility('CE') && showCannonExt" [label]="translate('Cannon Ext.')"
          [loading]="overviewIsLoading">
          <div class="condition">
            <span class="condition__side">L</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.CannonExtL}} mm</span> -->
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassCEL"
                  [data]="overviewModel.Equipment.CannonExtL"
                  (dataChanged)="updateReadings($event, Condition.CannonExtL,'CE_L')"
                  [alignRight]="true"></click-to-edit>
                {{measurementUnit}}
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.CannonExtCommentL != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.CannonExtCommentL == '' ? ('Add Comment' | translate | async) : overviewModel.Equipment.CannonExtCommentL"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.CannonExtCommentL.length > 0"
              (click)="openConditionComment(Condition.CannonExtL, overviewModel.Equipment.CannonExtCommentL)">
              chat_bubble{{overviewModel.Equipment.CannonExtCommentL.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.CannonExtPhotoL"
              [condition]="Condition.CannonExtL" (photoChange)="loadOverview()"></condition-photo>

          </div>
          <div class="condition">
            <span class="condition__side">R</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.CannonExtR}} mm</span> -->
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassCER"
                  [data]="overviewModel.Equipment.CannonExtR"
                  (dataChanged)="updateReadings($event, Condition.CannonExtR,'CE_R');"
                  [alignRight]="true"></click-to-edit>
                {{measurementUnit}}
              </div>
            </span>

            <i *ngIf="overviewModel.Equipment.CannonExtCommentR != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.CannonExtCommentR == '' ? 'Add Comment' : overviewModel.Equipment.CannonExtCommentR"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.CannonExtCommentR.length > 0"
              (click)="openConditionComment(Condition.CannonExtR, overviewModel.Equipment.CannonExtCommentR)">
              chat_bubble{{overviewModel.Equipment.CannonExtCommentR.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.CannonExtPhotoR"
              [condition]="Condition.CannonExtR" (photoChange)="loadOverview()"></condition-photo>
          </div>

          <div class="condition" *ngIf="overviewModel.Equipment.EnableEqualiserBar">
            <!--adding toe radio Button-->
            <mat-radio-group [(ngModel)]="ToeOutFrameIncorrect"
              (change)="updateUnderFootConditions(UnderFootConditions.ToeOut)">
              <mat-radio-button class="conditons-radio-buttons" [value]="true">
                {{'Toe Out' | translate | async}}</mat-radio-button>
            </mat-radio-group>
          </div>
          <!--adding toe radio Button-->
        </item>
        <item *ngIf="showUCCondition && visibility('S') && showScallop" [label]="translate('Scallop')"
          [loading]="overviewIsLoading">
          <div class="condition">
            <span class="condition__side">L</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.ScallopL
                }} mm</span> -->
                <span class="condition__reading">
                  <div>
                    <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassSL"
                                   [data]="overviewModel.Equipment.ScallopL"
                                   (dataChanged)="updateReadings($event, Condition.ScallopL,'S_L')"
                                   [alignRight]="true"></click-to-edit>{{measurementUnit}}
                  </div>
                </span>

                <i *ngIf="overviewModel.Equipment.ScallopCommentOnLeft != '' || isInspector"
                   [matTooltip]="overviewModel.Equipment.ScallopCommentOnLeft == '' ? 'Add Comment' : overviewModel.Equipment.ScallopCommentOnLeft"
                   class="material-icons condition__icon"
                   [class.has-comment]="overviewModel.Equipment.ScallopCommentOnLeft.length > 0"
                   (click)="openConditionComment(Condition.ScallopL, overviewModel.Equipment.ScallopCommentOnLeft)">
                  chat_bubble{{overviewModel.Equipment.ScallopCommentOnLeft.length > 0 ? '' : '_outline'}}
                </i>
                <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.ScallopPhotoOnLeft"
                                 [condition]="Condition.ScallopL" (photoChange)="loadOverview()"></condition-photo>

</div>
          <div class="condition">
            <span class="condition__side">R</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.ScallopR}} mm</span> -->
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector" [ngClass]="borderClassSR"
                  [data]="overviewModel.Equipment.ScallopR"
                  (dataChanged)="updateReadings($event, Condition.ScallopR,'S_R');"
                  [alignRight]="true"></click-to-edit>{{measurementUnit}}
              </div>
            </span>

            <i *ngIf="overviewModel.Equipment.ScallopCommentOnRight != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.ScallopCommentOnRight == '' ? 'Add Comment' : overviewModel.Equipment.ScallopCommentOnRight"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.ScallopCommentOnRight.length > 0"
              (click)="openConditionComment(Condition.ScallopR, overviewModel.Equipment.ScallopCommentOnRight)">
              chat_bubble{{overviewModel.Equipment.ScallopCommentOnRight.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.ScallopPhotoOnRight"
              [condition]="Condition.ScallopR" (photoChange)="loadOverview()"></condition-photo>

          </div>
          <!--adding toe radio Button-->
          <div class="condition" *ngIf="overviewModel.Equipment.EnableEqualiserBar">
            <mat-radio-group [(ngModel)]="ToeOutFrameIncorrect"
              (change)="updateUnderFootConditions(UnderFootConditions.Straight)">
              <mat-radio-button class="conditons-radio-buttons" [value]="false"> {{'Straight' | translate | async}}</mat-radio-button>
            </mat-radio-group>
          </div>
          <!--adding toe radio Button-->
        </item>

        <item *ngIf="showUCCondition && visibility('DJ') && showDryJoints" [label]="translate('Dry Joints')"
          [loading]="overviewIsLoading">
          <div class="condition">
            <span class="condition__side">L</span>
            <!-- <span class="condition__reading">{{overviewModel.Equipment.DryJointsL}} mm</span> -->
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                  [data]="overviewModel.Equipment.DryJointsL"
                  (dataChanged)="updateReadings($event, Condition.DryJointsL)" [alignRight]="true"></click-to-edit>
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.DryJointsCommentsOnLeft != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.DryJointsCommentsOnLeft == '' ? 'Add Comment' : overviewModel.Equipment.DryJointsCommentsOnLeft"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.DryJointsCommentsOnLeft.length > 0"
              (click)="openConditionComment(Condition.DryJointsL, overviewModel.Equipment.DryJointsCommentsOnLeft)">
              chat_bubble{{overviewModel.Equipment.DryJointsCommentsOnLeft.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.DryJointsPhotoOnLeft"
              [condition]="Condition.DryJointsL" (photoChange)="loadOverview()"></condition-photo>

          </div>
          <div class="condition">
            <span class="condition__side">R</span>
            <span class="condition__reading">
              <div>
                <click-to-edit *ngIf="!overviewIsLoading" [editable]="isInspector"
                  [data]="overviewModel.Equipment.DryJointsR"
                  (dataChanged)="updateReadings($event, Condition.DryJointsR)" [alignRight]="true"></click-to-edit>
              </div>
            </span>

            <i *ngIf="overviewModel.Equipment.DryJointsCommentsOnRight != '' || isInspector"
              [matTooltip]="overviewModel.Equipment.DryJointsCommentsOnRight == '' ? 'Add Comment' : overviewModel.Equipment.DryJointsCommentsOnRight"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.DryJointsCommentsOnRight.length > 0"
              (click)="openConditionComment(Condition.DryJointsR, overviewModel.Equipment.DryJointsCommentsOnRight)">
              chat_bubble{{overviewModel.Equipment.DryJointsCommentsOnRight.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.DryJointsPhotoOnRight"
              [condition]="Condition.DryJointsR" (photoChange)="loadOverview()"></condition-photo>

          </div>
        </item>

        <item *ngIf="showUCCondition && visibility('L') && showNumberOfLinks" [label]="translate('# of Links')"
          [loading]="overviewIsLoading">
          <div class="condition">
            <span class="condition__side">L</span>

            <span class="condition__reading">
              <div>
                <click-to-edit [disable_decimal]="true" *ngIf="!overviewIsLoading" [editable]="isInspector"
                  [data]="overviewModel.Equipment.LinkNoL" (dataChanged)="updateReadings($event, Condition.LinkNoL)"
                  [alignRight]="true"></click-to-edit>
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.LinkNoCommentsOnLeft != '' && overviewModel.Equipment.LinkNoCommentsOnLeft != null || isInspector"
              [matTooltip]="overviewModel.Equipment.LinkNoCommentsOnLeft == ''  && overviewModel.Equipment.LinkNoCommentsOnLeft == null? 'Add Comment' : overviewModel.Equipment.LinkNoCommentsOnLeft"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.LinkNoCommentsOnLeft.length > 0"
              (click)="openConditionComment(Condition.LinkNoL, overviewModel.Equipment.LinkNoCommentsOnLeft)">
              chat_bubble{{overviewModel.Equipment.LinkNoCommentsOnLeft.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.LinkNoPhotoOnLeft"
              [condition]="Condition.LinkNoL" (photoChange)="loadOverview()"></condition-photo>

          </div>
          <div class="condition">
            <span class="condition__side">R</span>

            <span class="condition__reading">
              <div>
                <click-to-edit [disable_decimal]="true" *ngIf="!overviewIsLoading" [editable]="isInspector"
                  [data]="overviewModel.Equipment.LinkNoR" (dataChanged)="updateReadings($event, Condition.LinkNoR)"
                  [alignRight]="true"></click-to-edit>
              </div>
            </span>
            <i *ngIf="overviewModel.Equipment.LinkNoCommentsOnRight != '' && overviewModel.Equipment.LinkNoCommentsOnRight != null || isInspector"
              [matTooltip]="overviewModel.Equipment.LinkNoCommentsOnRight == '' && overviewModel.Equipment.LinkNoCommentsOnRight == null? 'Add Comment' : overviewModel.Equipment.LinkNoCommentsOnRight"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.LinkNoCommentsOnRight.length > 0"
              (click)="openConditionComment(Condition.LinkNoR, overviewModel.Equipment.LinkNoCommentsOnRight)">
              chat_bubble{{overviewModel.Equipment.LinkNoCommentsOnRight.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.LinkNoPhotoOnRight"
              [condition]="Condition.LinkNoR" (photoChange)="loadOverview()"></condition-photo>

          </div>
        </item>

        <item [label]="translate('Tension Indicator Installed')" [loading]="overviewIsLoading"
          *ngIf="overviewModel.Equipment.EnableTrackTensionIndicator">
          <div class="condition">
            <span class="condition__side">L</span>

            <i [matTooltip]="overviewModel?.Equipment?.IndicatorLeftComment == '' ? 'Add Comment' : overviewModel?.Equipment?.IndicatorLeftComment"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.IndicatorLeftComment.length > 0"
              (click)="openConditionComment(Condition.IndicatorLeftComment, overviewModel?.Equipment?.IndicatorLeftComment)">
              chat_bubble{{overviewModel.Equipment.IndicatorLeftComment.length > 0 ? '' : '_outline'}}
            </i>

            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.IndicatorLeftImage"
              [condition]="Condition.IndicatorLeftImage" (photoChange)="loadOverview()"></condition-photo>

            <mat-radio-group [(ngModel)]="IsIndicatorLeft"
              (change)="updateUnderFootConditions(UnderFootConditions.Tension_Indicator_Left)">
              <mat-radio-button class="conditons-radio-buttons" [value]="1"> Yes</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="0">No </mat-radio-button>
            </mat-radio-group>
          </div>


          <div class="condition">
            <span class="condition__side">R</span>
            <i [matTooltip]="overviewModel?.Equipment?.IndicatorRightComment == '' ? 'Add Comment' : overviewModel?.Equipment?.IndicatorRightComment"
              class="material-icons condition__icon"
              [class.has-comment]="overviewModel.Equipment.IndicatorRightComment.length > 0"
              (click)="openConditionComment(Condition.IndicatorRightComment, overviewModel?.Equipment?.IndicatorRightComment)">
              chat_bubble{{overviewModel.Equipment.IndicatorRightComment.length > 0 ? '' : '_outline'}}
            </i>
            <condition-photo [inspectionId]="_inspectionId" [photo]="overviewModel.Equipment.IndicatorRightImage"
              [condition]="Condition.IndicatorRightImage" (photoChange)="loadOverview()"></condition-photo>

            <mat-radio-group [(ngModel)]="IsIndicatorRight"
              (change)="updateUnderFootConditions(UnderFootConditions.Tension_Indicator_Right)">
              <mat-radio-button class="conditons-radio-buttons" [value]="1"> Yes</mat-radio-button>
              <mat-radio-button class="conditons-radio-buttons" [value]="0">No </mat-radio-button>
            </mat-radio-group>
          </div>

        </item>
        <div class="no-margin-right" *ngIf="showThermalImages">
          <item [label]="translate('Thermal Images')" [loading]="overviewIsLoading">



            <div class="condition">
              <span class="condition__side">L</span>


              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesL01" [side]="1" [TphotoId]="1"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesL02" [side]="1" [TphotoId]="2"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesL03" [side]="1" [TphotoId]="3"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesL04" [side]="1" [TphotoId]="4"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesL05" [side]="1" [TphotoId]="5"
                (photoChange)="loadOverview()"></condition-photo>

            </div>
            <div class="condition">
              <span class="condition__side">R</span>

              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesR01" [side]="2" [TphotoId]="1"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesR02" [side]="2" [TphotoId]="2"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesR03" [side]="2" [TphotoId]="3"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesR04" [side]="2" [TphotoId]="4"
                (photoChange)="loadOverview()"></condition-photo>
              <condition-photo [inspectionId]="_inspectionId" [isThermal]="true"
                [photo]="overviewModel.Equipment.ThermalImagesR05" [side]="2" [TphotoId]="5"
                (photoChange)="loadOverview()"></condition-photo>


            </div>
          </item>
        </div>
      </item-group>
    </div>
<div>

<div class="row"  *ngIf="isInterpreter">
        <div class="bg-light border p-3">
            <h4>{{translate('Interpretation Comment')}}</h4>
           <div class="editor" *ngIf="loadingInterpretationComment">
          <angular-editor [(ngModel)]="interpretationComment" [config]="editorConfig"
            [placeholder]="'Enter text here...' | translate | async"></angular-editor>
          <button style="    float: right;   height: 37px; margin: 5px 0px;" *ngIf="isInterpreter" mat-raised-button
            color="warn" (click)="updateInterpretationComment()">{{'Save Commment' |
            translate | async}}</button>
        </div>
        </div>

        <div class="bg-secondary text-white border p-3">
          <div style="display:flex;gap:10px">
             <h4> {{ "Quotes & Recommendations" | translate | async }}</h4>
             <button style="float:right" mat-raised-button color="warn" (click)="OpenRecommendationPage()">{{'Add Recommendation' |
                    translate | async}}</button>
          </div>
             <div>
        <item-group>
          <item style="margin-left: 24px; margin-right: 24px; margin-top: 70px; margin-bottom: 5px; width:100%;"
            [loading]="overviewIsLoading">
            <div>
              <quote-container [inspectionId]="_inspectionId" (selectedQuoteIdChanged)="selectedQuoteIdChanged($event)"
                [recommmendationID]="recommmendationID"></quote-container>
                 
            </div>
          </item>
        </item-group>
      </div>
        </div>
    </div>


    <!-- <div class="panel info-panels " *ngIf="isInterpreter">
       <div class="form-item" style="width: 30%;">
        <label class="form-label" for="interpretationComment">{{translate('Interpretation Comment')}}</label>

        <div class="editor" *ngIf="loadingInterpretationComment">
          <angular-editor [(ngModel)]="interpretationComment" [config]="editorConfig"
            [placeholder]="'Enter text here...'"></angular-editor>
          <button style="    float: right;   height: 37px; margin: 5px 0px;" *ngIf="isInterpreter" mat-raised-button
            color="warn" (click)="updateInterpretationComment()">{{'Save Commment' |
            translate | async}}</button>
        </div>
        
      </div>
      <div class="panel__header">
        <span class="panel__header__title">
          {{ "Quotes & Recommendations" | translate | async }}
        </span>
      </div>
      <div>
        <item-group>
          <item style="margin-left: 24px; margin-right: 24px; margin-top: 70px; margin-bottom: 5px; width:100%;"
            [loading]="overviewIsLoading">
            <div style="margin-top: 0px; left: 15%; position: absolute; width: 85%;">
              <div style="display:flex;">
              
                <div>
                  <button mat-raised-button color="warn" (click)="OpenRecommendationPage()">{{'Add Recommendation' |
                    translate | async}}</button>
                </div>
              
              </div>
            </div>
            <div>
              <quote-container [inspectionId]="_inspectionId" (selectedQuoteIdChanged)="selectedQuoteIdChanged($event)"
                [recommmendationID]="recommmendationID"></quote-container>
            </div>
          </item>
        </item-group>
      </div>
    </div> -->
</div>
   
    <div class="panel info-panels" *ngIf="flaggedComponents?.length>0">
      <div class="panel__header">
        <span class="panel__header__title">
          {{ "Flagged Components" | translate | async }}
        </span>
      </div>
      <div>
        <item-group>
          <item style="margin-left: 24px; margin-right: 24px; margin-top: 0px; margin-bottom: 5px; width:100%;"
            [loading]="overviewIsLoading">

            <div style="display:flex;margin-left: 13%;">

              <div class="input-grouping" style="padding-top: 1px; padding-left: 10px;">
                <span class="input-grouping__reading">
                  <span class="input-grouping__side">{{ "Action Date" | translate | async }}</span>
                  <input class="input-travel rule-textboxes" (click)="picker1.open()" readonly [matDatepicker]="picker1"
                    placeholder="Choose a date" [(ngModel)]="recordActionDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </span>
              </div>
              <div class="input-grouping"
                style="padding-top: 2px; padding-left: 10px; margin-top: 2px;padding-right: 10px;">
                <span class="input-grouping__reading" style="display:flex; align-items:center;">
                  <span class="input-grouping__side" style=" padding-right: 5px; ">{{ "Action SMU" | translate | async
                    }}</span>
                  <input type="number" matInput [(ngModel)]="recordActionSMU" class="rule-textboxes"
                    style="border: revert;">
                </span>
              </div>
              <button mat-raised-button color="warn" [disabled]="savingForm" [class.loading]="savingForm"
                (click)="RecordAction()">{{'Record Action' | translate | async}}</button>
              <div style="padding-left:5%; display: none;">
                <button mat-raised-button color="warn" (click)="LoadFlaggedComponents()">{{'Reload' | translate |
                  async}}</button>
              </div>

            </div>
            <table class="table table--full-width">
              <thead>
                <tr>
                  <th class="fc">{{ "Component" | translate | async }}</th>
                  <th class="fc">{{ "Description" | translate | async }}</th>
                  <th class="fc">{{ "Side" | translate | async }}</th>
                  <th class="fc">{{ "Position" | translate | async }}</th>
                  <th class="fc">{{ "Brand" | translate | async }}</th>
                  <th class="fc">{{ "Delete" | translate | async }}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let comp of flaggedComponents;let i = index">
                  <tr>
                    <td>{{comp.Description}}</td>
                    <td>{{comp.OldComponent}}</td>
                    <td>{{comp.Side}}</td>
                    <td>{{comp.Pos}}</td>
                    <td>{{comp.Brand}}</td>
                    <td> <i class="material-icons button__icon" style="color: red; cursor: pointer; "
                        (click)="RemoveRecord(i, comp.Id)">close</i></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>

          </item>


        </item-group>
      </div>
    </div>
  </div>
  <div class="tabs tabs--max-width" *ngIf="hasPermission">
    <mat-tab-group [(selectedIndex)]="selectedTab" (click)="ReloadPage()">
      <mat-tab [label]="translate('Components')">
        <div [@listAnimation]="systemIds.length" *ngIf="selectedTab == 0">
          <div class="columnsheadersmgr">
            <span class="displaycolumnheadersfor">{{ "Display Columns for" | translate | async }}:</span>
            <mat-checkbox [(ngModel)]="showCMU">
              <span class="example-margin item__bottom">
                {{
                "CMU" | translate | async
                }}
              </span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="showResLife100">
              <span class="example-margin">
                {{
                "Res. Life" | translate |
                async
                }} 100%
              </span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="showResLife120">
              <span class="example-margin">
                {{
                "Res. Life" | translate |
                async
                }} 120%
              </span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="showDOC" *ngIf="overviewModel.Equipment.showDistTravelledTracking">
              <span class="example-margin">{{ "DOC" | translate | async }}</span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="showResDOC100" *ngIf="overviewModel.Equipment.showDistTravelledTracking">
              <span class="example-margin">{{ "Res. DOC" | translate | async }} 100%</span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="showResDOC120" *ngIf="overviewModel.Equipment.showDistTravelledTracking">
              <span class="example-margin">{{ "Res. DOC" | translate | async }} 120%</span>
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="editComponentType" style="display: none;">
              <span class="example-margin">{{ "Edit Component Type" | translate | async }}</span>
            </mat-checkbox>
          </div>
          <div *ngFor="let systemId of systemIds">
            <system [InspectionSMU]="overviewModel?.Equipment?.SMU" [systemId]="systemId"
              [EvalautionRange]="EvalautionRange" [equipmentID]="equipmentID"
              [ShowHideCRoller]="overviewModel?.Equipment?.ShowHideCRoller"
              (measurementPointUpdated)="childMeasurementPointUpdated()"
              (ComponentCommentUpdated)="ComponentCommentUpdated()" [inspectionId]="_inspectionId"
              [selectedQuoteId]="selectedQuoteId" [Family_]="Family" [FamilyImage_Chain]="FamilyImage_Chain"
              [FamilyImage_Frame]="FamilyImage_Frame" (reloadSelectedQuote)="reloadQuotes($event)"
              [isParentChanged]="isParentChanged" (reloadFlaggedComponents)="reloadFlaggedComponents()"
              [showDistTravelledTracking]="overviewModel.Equipment.showDistTravelledTracking" [showCMU]="showCMU"
              [showResLife100]="showResLife100" [showResLife120]="showResLife120" [showDOC]="showDOC"
              [showResDOC100]="showResDOC100" [showResDOC120]="showResDOC120" [editComponentType]="editComponentType">
            </system>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Additional Observations')" *ngIf="isInspector">
        <div style="margin: 16px 0;" *ngIf="selectedTab == 1">
          <inspection-additional-observation [PopupEndPoint]="2" [inspectionId]="_inspectionId">
          </inspection-additional-observation>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Bar Chart')">
        <div [@listAnimation]="systemIds.length" *ngIf="selectedTab == 2">
          <div class="bar-settings">
            <button *ngIf="barGraphView == BarGraphView.Compact" mat-raised-button matTooltip="Toggle Expanded View"
              (click)="setBarGraphView(BarGraphView.Expanded)">
              <i class="material-icons">view_stream</i>
            </button>
            <button *ngIf="barGraphView == BarGraphView.Expanded" mat-raised-button matTooltip="Toggle Compact View"
              (click)="setBarGraphView(BarGraphView.Compact)">
              <i class="material-icons">view_headline</i>
            </button>
            <button mat-raised-button matTooltip="Zoom Out" (click)="zoomInBarGraph()">
              <i class="material-icons">zoom_out</i>
            </button>
            <button mat-raised-button matTooltip="Zoom In" (click)="zoomOutBarGraph()">
              <i class="material-icons">zoom_in</i>
            </button>
            <button mat-raised-button matToolip="Change SMU/Hourmeter Interval" [matMenuTriggerFor]="intervalMenu">
              <span style="vertical-align: middle; margin-right: 8px;">
                {{smuInterval}}
                SMU/{{'Hourmeter' | translate | async}}
              </span><i class="material-icons">arrow_drop_down</i>
            </button>
            <mat-menu #intervalMenu="matMenu">
              <button mat-menu-item (click)="setBarGraphInterval(100)">100</button>
              <button mat-menu-item (click)="setBarGraphInterval(500)">500</button>
              <button mat-menu-item (click)="setBarGraphInterval(1000)">1000</button>
              <button mat-menu-item (click)="setBarGraphInterval(2500)">2500</button>
              <button mat-menu-item (click)="setBarGraphInterval(5000)">5000</button>
            </mat-menu>
          </div>

          <div *ngFor="let systemId of systemIds">
            <system-graph [systemId]="systemId" [inspectionId]="_inspectionId" [selectedQuoteId]="selectedQuoteId"
              [EvalautionRange]="EvalautionRange" [Family_]="Family"
              (reloadSelectedQuote)="reloadQuotes($event)"></system-graph>
          </div>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Audit Log')" *ngIf="isInspector">
        <div style="margin: 16px 0;" *ngIf="selectedTab == 3">
          <audit-log [inspectionId]="_inspectionId"></audit-log>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Forecast')">
        <div style="margin: 16px 0;" *ngIf="selectedTab == 4">
          <forecast-undercariage [inspectionId]="_inspectionId" [EvalautionRange]="EvalautionRange"
            [unitNo]="overviewModel.Equipment.UnitNumber"></forecast-undercariage>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Temperature Inspection')" *ngIf="overviewModel.TempInspectionId>0 && isInspector">
        <div style="margin: 16px 0;" *ngIf="selectedTab == 5">
          <app-temperature-inspection [TemperatureInspectionList]="TemperatureInspectionList"
            [inspectionId]="overviewModel.TempInspectionId"
            [equipmentId]="overviewModel.Equipment.EquipmentId"></app-temperature-inspection>
        </div>
      </mat-tab>
      <mat-tab [label]="translate('Forecast')" *ngIf="isForecastOn">
        <div [@listAnimation]="systemIds.length">
          <app-forecast-interpretation-settings></app-forecast-interpretation-settings>
          <div *ngFor="let systemId of systemIds">
            <app-forecast-interpretation [systemId]="systemId" [EvalautionRange]="EvalautionRange"
              [equipmentID]="equipmentID" (measurementPointUpdated)="childMeasurementPointUpdated()"
              [inspectionId]="_inspectionId" [selectedQuoteId]="selectedQuoteId" [Family_]="Family"
              [FamilyImage_Chain]="FamilyImage_Chain" [FamilyImage_Frame]="FamilyImage_Frame"
              (reloadSelectedQuote)="reloadQuotes($event)"></app-forecast-interpretation>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>



</div>

<div *ngIf="!hasPermission && !checkingForPermission">
  <no-permission [reason]="noPermissionReason"></no-permission>
</div>
<div *ngIf="checkingForPermission" class="permission" style="width: 100%;">
  <div style="margin: 124px auto;" class="permission__text">
    <span class="permission__spinner" style="margin-right: 16px; ">{{translate('Checking Permission')}}</span>
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</div>


<div class="modal-backdrop" *ngIf="IspopupOpen">
  <div class="modal-box">
    <div class="row">
      <div class="col-lg-12" style=" background-color: #fff;
    /* padding: 0px 24px 24px 24px; */
    border-radius: 8px;
    width: 292px;
    cursor: pointer;
    display: flex
;
    justify-content: space-between;
    align-items: center;">
        <h3>Select</h3>
        <i class="material-icons ttmodal__close-button" (click)="closePopup()" matTooltip="Close">close</i>
      </div>
    </div>

    <mat-form-field style="width: 100%;">
      <mat-label>Select Customer</mat-label>
      <mat-select name="customer" [(ngModel)]="CustomerId">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let customer of customerListFliter" [value]="customer.Id">
          {{ customer.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <mat-form-field style="width: 100%;">
      <mat-label>Select Jobsite</mat-label>
      <mat-select name="jobsite" placeholder="{{'Select Jobsite' | translate | async}}" [(ngModel)]="JobsiteId"
        (selectionChange)="GetEquipment()">
        <mat-option>None</mat-option>
        <mat-option *ngFor="let jobsite of jobSiteListFilter" [value]="jobsite.Id">
          {{ jobsite.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%;">
      <input matInput (focus)="focus(6)" #modelAutoCompleteInput placeholder="Model" aria-label="Model"
        [matAutocomplete]="autoModel" [formControl]="modelCtrl" [disabled]="true">
      <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="modelSelected($event, modelAutoCompleteInput)">
        <mat-option *ngFor="let model of filteredModels | async" [value]="model">
          <span>{{ model.Title }}</span>
          <small></small>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field style="width: 100%;">
      <mat-select [autofocus]="true" #equipmentSelect placeholder="{{'Select Equipment' | translate | async}}" name="Select Equipment"
        [(ngModel)]="selectedEquipment">
        <mat-option *ngFor="let equip of EquipmentModels" [value]="equip.Id">
          {{equip.Title}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div style="display: flex; justify-content: space-between; margin-top: 16px;">
      <button mat-button (click)="RemoveLink()">Remove Link</button>
      <button mat-raised-button color="warn" (click)="createLink(1)">Create Link</button>
    </div>
  </div>
</div>


<div class="modal-backdrop" *ngIf="IspopupOpen1">
  <div class="modal-box-Unmatched">
    <div class="row">
      <div class="col-lg-12" style="display: flex;justify-content: space-between;">
        <h3>Un-Match Components</h3>
        <i class="material-icons ttmodal__close-button" (click)="closePopupSource()" matTooltip="Close">close</i>
      </div>
    </div>

    <table class="table table--full-width">
      <thead>
        <tr>
          <th class="fc">{{ "Component" | translate | async }}</th>
          <th class="fc">{{ "Side" | translate | async }}</th>
          <th class="fc">{{ "Position" | translate | async }}</th>
          <th class="fc">Source Component</th>

          <th class="fc">Destination Component</th>

        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let comp of Data;let i = index">
          <tr>
            <td>{{comp.Component}}</td>
            <td>{{comp.Side}}</td>
            <td>{{comp.Position}}</td>
            <td>{{comp.SourceCompartName}}</td>
            <td>{{comp.DestinationCompartName}}</td>
            <!-- <td> <i class="material-icons button__icon" style="color: red; cursor: pointer; "
                    (click)="RemoveRecord(i, comp.Id)">close</i></td> -->
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
